export default "__VITE_ASSET__CPW4HA7Q__"